var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"\n        lg:backdrop-filter lg:backdrop-blur-lg lg:shadow\n        sm:rounded-md\n        z-20\n        relative\n        backdrop-filter-fallback\n    "},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }